module.exports = __webpack_public_path__ + "static/flags/NP-00be6e76ebb5f033b4c493e8ec0a39ef.gif";